import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExerciseInfoComponent } from './exercise-info.component';
import { NumberToTimePipeModule } from 'src/app/pipes/number-to-time.pipe';


@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    NumberToTimePipeModule
  ],
  exports: [ExerciseInfoComponent],
  declarations: [ExerciseInfoComponent]
})
export class ExerciseInfoComponentModule {}
